// extracted by mini-css-extract-plugin
export default {"scoll_container":"scroll-to-top_scoll_container__VfUSM"};